// src/components/NotAuthorized.tsx
import React from 'react';
import { Box, Typography, Button } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import BlockIcon from '@mui/icons-material/Block';

const NotAuthorized: React.FC = () => {
    const navigate = useNavigate();
    
    return (
        <Box sx={{ 
            display: 'flex', 
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            minHeight: '100vh',
            p: 3
        }}>
            <BlockIcon sx={{ fontSize: 64, color: 'error.main', mb: 2 }} />
            <Typography variant="h4" gutterBottom>
                No Autorizado
            </Typography>
            <Typography variant="body1" color="text.secondary" sx={{ mb: 3 }}>
                No tienes permisos para acceder a este recurso.
            </Typography>
            <Button 
                variant="contained" 
                onClick={() => navigate('/')}
            >
                Volver al inicio
            </Button>
        </Box>
    );
};

export default NotAuthorized;